import useUserData from 'hooks/useUserData';
import React, { useContext, useEffect, useState } from 'react';
import { getSurveysData, setSurveysData } from './SurveysStorage';

export interface SurveysContextProps {
  loaded: boolean;
  avalibleSurvey: string;
  enabledSendAnswers: boolean;
  visitedPage: boolean;
  showTooltip: boolean;
  setAnswered: () => void;
  setVisited: () => void;
  setShowTooltip: (value: boolean) => void;
}

const defaultContext: SurveysContextProps = {
  loaded: false,
  avalibleSurvey: '',
  enabledSendAnswers: false,
  visitedPage: false,
  showTooltip: false,
  setAnswered: () => {
    ///asdasdasd
  },
  setVisited: () => {
    ///asdasdasdasd
  },
  setShowTooltip: () => {
    //skljlkjs
  },
};

const Context = React.createContext<SurveysContextProps>(defaultContext);

const SurveysContext = (props: React.PropsWithChildren<{}>) => {
  const [loaded, setLoaded] = useState(false);
  const [avalibleSurvey, setAvalibleSurvey] = useState('');
  const [visitedPage, setVisitedPage] = useState(false);
  const [enabledSendAnswers, setEnabledSendAnswers] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const userData = useUserData();

  const setAnswered = () => {
    if (!avalibleSurvey) return;
    setEnabledSendAnswers(false);
    setSurveysData(avalibleSurvey, { answered: new Date() });
  };
  const setVisited = () => {
    if (!avalibleSurvey) return;
    setVisitedPage(true);
    setSurveysData(avalibleSurvey, { visited: new Date() });
  };

  useEffect(() => {
    if (!userData) return;
    let surveyName = '';

    // surveyName = 'surveyMonitoringTSOR';

    if (surveyName) {
      const data = getSurveysData(surveyName);
      setAvalibleSurvey(surveyName);
      if (!data.answered) {
        setEnabledSendAnswers(true);
      }
      if (data.visited) {
        setVisitedPage(true);
      }
    }
    setLoaded(true);
  }, [userData]);

  return (
    <Context.Provider
      value={{
        loaded,
        avalibleSurvey,
        visitedPage,
        enabledSendAnswers,
        setAnswered,
        setVisited,
        showTooltip,
        setShowTooltip,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const useSurveysContext = () => useContext(Context);

export default SurveysContext;
